import React, { useRef, useState, createContext } from "react";
import { Link } from "react-router-dom";
import { StarsList } from "component/Rating";
import { usePopper } from "react-popper";
import "./index.scss";
import { useEffect } from "react";
import api from "api";
import _ from "lodash";
import msGraph, { MSGraphAuthenticator } from '../../msal';
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import LastSeen from "component/LastSeen";
import fancybox from "component/Fancybox/Fancybox";
import { MessagingBox } from "component/MessagingBox";
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { FollowButton } from "component/Follow";

const userPhotoContext = createContext(false);

const AvatarMessage = connect(stateMap)(props => {
    const [isDisallowed, setIsDissalowed]   = useState(false);
    const [isProcess, setIsProcess]         = useState(true);

    useEffect(() => {
        api('/Messaging/IsDisallowed', 'get', {
            user_id : props.user.UserID
        }, 'Bearer ' + props.auth.token)
            .then((response) => {
                setIsProcess(false);
                setIsDissalowed(response.is_disallowed);
            })
            .catch(error => {
                setIsProcess(false);
                setIsDissalowed(true);
            })
    }, []);

    return (
        isProcess ? <span className="skeleton"></span> :
        (
            !isDisallowed && 
            <button className={props.className || "btn-block btn btn-mini btn-orange" } onClick={e => {
                e.preventDefault();
    
                if(isDisallowed)
                {
                    return;
                }
    
                fancybox(
                    <div className="w-800">
                        <MessagingBox chat_user={props.user.UserID}/>
                    </div>
                )
            }}>Message</button>
        )
    )
})

const AvatarGetPicture = (user) => {
    return user.UserPhoto ? user.UserPhoto : `${process.env.PUBLIC_URL}/assets/image/avatar.jpg`;
}

const AvatarReducer = (user, prefix) => {
    return {
        UserName            : user[prefix + 'UserName']
        ,UserDisplayName    : user[prefix + 'UserDisplayName']
        ,IsAdmin            : user[prefix + 'IsAdmin'] ? user[prefix + 'IsAdmin'] : ''
        ,UserID             : user[prefix + 'UserID'] ? user[prefix + 'UserID'] : ''
        ,UserPhoto          : user[prefix + 'UserPhoto'] ? user[prefix + 'UserPhoto'] : ''
    };
}

const AvatarPopup = (user, userRating, userDisplayed) => {
    return (
        <div className="component-avatar-popup">
            <div className="component-avatar-popup-wrapper identity-wrapper">
                <div className="avatar-img">
                    <Link className="image-box square circle" to={{
                        pathname : '/user/' + user.UserName
                    }}>
                        {
                            !user.UserPhoto ? <InitialsAvatar name={user.UserDisplayName} /> 
                            : <img src={AvatarGetPicture(user)} alt={ user.UserDisplayName } />
                        }
                    </Link>
                </div>
                <div className="avatar-identity">
                    <Link className="user-name" to={{
                        pathname : '/user/' + user.UserName
                    }}>
                        <span className="leading-loose">
                            { user.UserDisplayName }
                        </span>
                    </Link>
                    <span className="last-seen text-xs block mt-sm">
                        {
                            userDisplayed !== false && user && <LastSeen user_id={user.UserID} />
                        }
                    </span>
                    <span className="avatar-metadata"></span>
                </div>
            </div>
            {
                user.UserID &&
                <div className="avatar-card-action-box" style={{padding: '10px'}}>
                    <div className="message-action-box">
                        {
                            userDisplayed && <AvatarMessage user={user}/>
                        }
                    </div>
                    <div className="profile-action-box">
                        <Link className="btn btn-orange btn-block btn-mini" to={{
                            pathname : '/user/' + user.UserName
                        }}>Profile</Link>
                    </div>
                    {
                        userDisplayed &&
                        <div className="follow-action-box">
                            <FollowButton user={user} className="btn-block btn btn-mini btn-primary"/>
                        </div>
                    }
                </div>
            }
            <hr />
            <div className="component-avatar-popup-wrapper">
                <span className="block font-bold text-xs mb-sm text-left">Rating</span>
                {
                    userRating === false ? <span className="skeleton"></span> :
                    <div className="flex flex-wrap">
                        <span className="block font-bold">{userRating}</span>&nbsp;
                        <StarsList score={userRating}/>
                    </div>
                }
            </div>
        </div>
    )
}

const AvatarScaffold = connect(stateMap)(props => {
    const [user]                                    = useState(props.user);
    const [referenceElement, setReferenceElement]   = useState(null);
    const [popperElement, setPopperElement]         = useState(null);
    const {styles}                                  = usePopper(referenceElement, popperElement, {
        placement : props.placement || 'top-start'
    });
    const [showContent, setShowContent]             = useState(false);
    const [userRating, setUserRating]               = useState(false);
    const [userPhoto, setUserPhoto]                 = useState(false);
    const [userDisplayed, setUserDisplayed]         = useState(false);

    useEffect(() => {
        if(!user)
        {
            msGraph(`/users/${user.UserEmail}/photo/$value`, props.auth.user.Token3rd)
                .then(response => {
                    const url       = window.URL || window.webkitURL;
                    setUserPhoto(url.createObjectURL(response.blob()))
                })
                .catch(error => {
    
                })
        }
    }, [user]);
 
    return (
        <div 
            className="component-avatar"
            ref={setReferenceElement}
            onMouseEnter={(e) => {

                if(!props.auth.user)
                {
                    return;
                }
                
                if(userRating === false && user)
                {
                    api('/Profile/Rating', 'get', {
                        user_id : user.UserID
                    })
                        .then((response) => {
                            setUserRating(response.rating);
                        })
                        .catch(() => {
                            setUserRating('-');
                        });
                }

                setUserDisplayed(true);

                setShowContent(true);
            }}
            onMouseLeave={(e) => {;
                setShowContent(false);
            }}
        >
            <userPhotoContext.Provider value={userPhoto}>
                {props.children}
            </userPhotoContext.Provider>
            {
                user.UserID != props.auth.user.UserID && !user.disable_user_card &&
                <div ref={setPopperElement} style={_.assignIn({}, styles.popper, {
                    visibility : showContent ? 'visible' : 'hidden'
                    ,zIndex : 9
                }) }>{AvatarPopup(user, userRating, userDisplayed)}</div>
            }
        </div>
        
    )
});

const AvatarPicture1 = (props) => {
    const [user, setUser] = useState(props.user);
    useEffect(() => {
        setUser(props.user);
    }, [props.user]);
    return (
        <AvatarScaffold user={user} placement="top-start" >
            <div className="avatar-picture-1">
                <div className="avatar-img">
                    <span className="image-box square circle">
                        {
                            !user.UserPhoto ? <InitialsAvatar name={user.UserDisplayName} /> 
                            : <img src={AvatarGetPicture(user)} alt={ user.UserDisplayName } />
                        }
                    </span>
                </div>
            </div>
        </AvatarScaffold>
    )
}

const AvatarHorizontal1 = (props) => {
    const [user, setUser] = useState(props.user);
    useEffect(() => {
        setUser(props.user);
    }, [props.user]);
    return (
        <AvatarScaffold user={props.user} placement="top-start">
            <div className="avatar-horizontal avatar-horizontal-1">
                <div className="avatar-img">
                    <span className="image-box square circle">
                        {
                            !user.UserPhoto ? <InitialsAvatar name={user.UserDisplayName} /> 
                            : <img src={AvatarGetPicture(user)} alt={ user.UserDisplayName } />
                        }
                    </span>
                </div>
                <div className="avatar-identity">
                    <span className="user-name">
                        { user.UserDisplayName }
                        {
                            user.IsAdmin && <span className="avatar-user-is-creator">CREATOR</span>
                        }
                    </span>
                    <span className="avatar-metadata">{props.metadata}</span>
                </div>
            </div>
        </AvatarScaffold>
    )
}

const AvatarHorizontal2 = (props) => {
    const [user, setUser] = useState(props.user);
    useEffect(() => {
        setUser(props.user);
    }, [props.user]);
    
    return (
        <AvatarScaffold user={user} placement="auto-start">
            <div className="avatar-horizontal avatar-horizontal-2">
                <div className="avatar-img">
                    <Link className="image-box square circle" target="_blank" to={{
                        pathname : '/user/' + user.UserName
                    }}>
                        {
                            !user.UserPhoto ? <InitialsAvatar name={user.UserDisplayName} /> 
                            : <img src={AvatarGetPicture(user)} alt={ user.UserDisplayName } />
                        }
                    </Link>
                </div>
                <div className="avatar-identity">
                    <Link className="user-name" target="_blank" to={{
                        pathname : '/user/' + user.UserName
                    }}>
                        { user.UserDisplayName }
                        {
                            user.IsAdmin && <span className="avatar-user-is-creator">CREATOR</span>
                        }
                    </Link>
                    <span className="avatar-metadata">{props.metadata}</span>
                </div>
            </div>
        </AvatarScaffold>
    )
}

const AvatarVertical1 = (props) => {
    const [user, setUser] = useState(props.user);
    useEffect(() => {
        setUser(props.user);
    }, [props.user]);

    return (
        
        <AvatarScaffold user={user} placement="top-start">
            <userPhotoContext.Consumer>
                {
                    (photo) => {
                        return (
                            <div className="avatar-vertical avatar-vertical-1" >
                                <div className="avatar-img">
                                    <Link className="image-box square circle" target="_blank" to={{
                                        pathname : '/user/' + user.UserName
                                    }}>
                                        {
                                            !user.UserPhoto ? <InitialsAvatar name={user.UserDisplayName} /> 
                                            : <img src={AvatarGetPicture(user)} alt={ user.UserDisplayName } />
                                        }
                                    </Link>
                                </div>
                                <div className="avatar-identity">
                                    <Link className="user-name" target="_blank" to={{
                                        pathname : '/user/' + user.UserName
                                    }}>
                                        <span className="leading-tight">
                                        { user.UserDisplayName }
                                        </span>
                                        {
                                            user.IsAdmin && <span className="avatar-user-is-creator">CREATOR</span>
                                        }
                                    </Link>
                                    <span className="avatar-metadata">{props.metadata}</span>
                                </div>
                                {props.children}
                            </div>
                        )
                    } 
                }
            </userPhotoContext.Consumer>
        </AvatarScaffold>
    )
}

const AvatarVertical2 = (props) => {
    const [user, setUser] = useState(props.user);
    useEffect(() => {
        setUser(props.user);
    }, [props.user]);

    return (
        <AvatarScaffold user={user} placement="top">
            <div className="avatar-vertical avatar-vertical-2">
                <div className="avatar-img relative">
                    <Link className="image-box square circle" to={{
                        pathname : '/user/' + user.UserName
                    }}>
                        {
                            !user.UserPhoto ? <InitialsAvatar name={user.UserDisplayName} /> 
                            : <img src={AvatarGetPicture(user)} alt={ user.UserDisplayName } />
                        }
                    </Link>
                    {
                        user.UserLabel && <span className="avatar-image-label">{user.UserLabel}</span>
                    }
                </div>
                <div className="avatar-identity">
                    <Link className="user-name" to={{
                        pathname : '/user/' + user.UserName
                    }}>
                        { user.UserDisplayName }
                        {
                            user.IsAdmin && <span className="avatar-user-is-creator">CREATOR</span>
                        }
                    </Link>
                    <span className="avatar-metadata">{props.metadata}</span>
                </div>
            </div>
        </AvatarScaffold>
    )
}

const AvatarVertical3 = (props) => {
    const [user, setUser] = useState(props.user);
    useEffect(() => {
        setUser(props.user);
    }, [props.user]);

    return (
        <AvatarScaffold user={user} placement="top">
            <div className="avatar-vertical avatar-vertical-3">
                <div className="avatar-img">
                    <Link className="image-box square circle" to={{
                        pathname : '/user/' + user.UserName
                    }}>
                        {
                            !user.UserPhoto ? <InitialsAvatar name={user.UserDisplayName} /> 
                            : <img src={AvatarGetPicture(user)} alt={ user.UserDisplayName } />
                        }
                    </Link>
                </div>
                
                <div className="avatar-identity">
                    <Link className="user-name" to={{
                        pathname : '/user/' + user.UserName
                    }}>
                        { user.UserDisplayName }
                        {
                            user.IsAdmin && <span className="avatar-user-is-creator">CREATOR</span>
                        }
                    </Link>
                    <span className="avatar-metadata">{props.metadata}</span>
                </div>
                <div className="text-center profile-button">
                    <Link className="btn btn-primary" to={{
                        pathname : '/user/' + user.UserName
                    }}>Go To Profile</Link>
                </div>
            </div>
        </AvatarScaffold>
    )
}

export {AvatarMessage, AvatarHorizontal1, AvatarHorizontal2, AvatarVertical3, AvatarVertical1, AvatarVertical2, AvatarReducer, AvatarPicture1, AvatarGetPicture}